import { useEffect } from 'react';

const useResize = resize => {
  // const resize = useCallback(() => {
  //   if (window.innerWidth <= TABLET_BREAKPOINT) {
  //     setColumnsLength(TABLET_COLUMNS);
  //   } else {
  //     setColumnsLength(DESKTOP_COLUMNS);
  //   }
  // }, [DESKTOP_COLUMNS]);
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [resize]);
};

export default useResize;
